// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.c140e2f8e',
  revision: 'c140e2f8e',
  branch: 'develop',
  date: 'Tue, 16 Jun 2026 18:54:16 GMT'
};